/**
 * Points the admin to the AI Providers section when no AI Provider exists
 * yet — the LLM Profile form has nothing to select and cannot be submitted
 * (spec FR-013, US3).
 *
 * A same-page anchor rather than a route Link: the AI Providers section lives
 * on this same combined page, so navigating away would be wrong.
 */
export function NoAiProvidersEmptyState() {
  return (
    <p className="text-muted-foreground text-sm">
      No AI Providers exist yet.{' '}
      <a href="#ai-providers-section" className="text-foreground underline">
        Create one
      </a>{' '}
      before adding an LLM Profile.
    </p>
  );
}
